import { useEffect, useState } from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { getDefaultTheme, getThemeToProvide } from './ThemeProvider.helpers';
import { ThemeMetadataContextProvider } from './ThemeMetadataContext';
import devLogger from 'react-utils/devLogger';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The `ThemeProvider` provides the theme object for your app via
 * React Context. Foundations components **will not work without it**.
 * This `ThemeProvider` is used by the `AppProvider` component,
 * which is the top-level component that should wrap your entire app.
 * However, it can also be used on its own lower in your component tree
 * if you need to override the theme for a specific subtree. This could
 * be useful for opt-in user testing purposes.
 *
 * This component is also used by `hs-test-utils` to wrap all unit test
 * component trees.
 */
export const ThemeProvider = ({
  themeName = 'classic',
  themeMode = 'light',
  children
}) => {
  const [theme, setTheme] = useState(getDefaultTheme());
  useEffect(() => {
    getThemeToProvide(themeName, themeMode).then(themeObject => {
      setTheme(themeObject);
    }).catch(error => {
      devLogger.warn({
        message: `Failed to load theme with error: ${error}`,
        key: 'foundations-theming:theme-provider:theme-load-failure'
      });
    });
  }, [themeName, themeMode]);
  return /*#__PURE__*/_jsx(StyledComponentsThemeProvider, {
    theme: theme,
    children: /*#__PURE__*/_jsx(ThemeMetadataContextProvider, {
      themeName: themeName,
      themeMode: themeMode,
      children: children
    })
  });
};